import * as React from "react";
import axios from "axios";
import "../App.scss";
import Cookies from "js-cookie";
import { v4 as uuid } from "uuid";

import { useId, useState } from 'react';

import {
  addVotedIDToStorage,
  isVotedIdInStorage,
} from "../interfaces/votedCookieInterface";

import BallotInterface from "../interfaces/ballotInterface";
import VoteInterface from "../interfaces/voteInterface";
import promptInterface from "../interfaces/promptInterface";
import { BallotContext } from "../context/BallotContext";
import { StateContext } from "../context/StateContext";

export default function BallotComponent() {
  const { currentBallot, setCurrentBallot } = React.useContext(BallotContext);
  const { currentState, setGlobalState }= React.useContext(StateContext);

  const userInputDataID = useId();
  const [userInputData, setUserInputData] = useState('');

  // Get (or create) unique ID for this patron
  const [userID2, setUserID2] = useState("initializing");
  if (userID2 == "initializing") {
    const c = Cookies.get("UserID2");
    if (c == null) {
      // generate  unique random identifier
      const unique_id = uuid();
      Cookies.set("UserID2", unique_id, { expires: 7, path: "/" });
      setUserID2(unique_id);
    } else {
      setUserID2(c);
    }
  }
  
  // does the post request for the actual vote
  const DoVote = (p: promptInterface) => {
    console.log("Voting")
    const vote: VoteInterface = { 
      ballotID: currentBallot.id, 
      promptID: p.id, 
      userInputData: userInputData, 
      userID2: userID2 
    };
    axios
    .post<BallotInterface>(process.env.REACT_APP_HOST + "/vote", vote)
    .then((response) => {
      setCurrentBallot(response.data);
    })
    .catch((ex) => {
      const error = "An unexpected error has occurred. Could not vote";
    });
    addVotedIDToStorage(currentBallot.id);
    setUserInputData('')
    console.log("Voted - Ballot ID: " + currentBallot.id + ", Prompt ID: " + p.id)
  };
  
  // console.log ("Current fade state:" + currentState.fade);
  const f = currentState.fade
  // console.log ("f:" + f); 

  const hideInput = !currentBallot.acceptUserInput;

  var className = "container fadestate ";
  if (f) {
    className += " active";
  } else {
    className += " inactive";
  }

  if (currentBallot.id == "1020.1") { // Choose random color and shape
    const coloredshape = ["red-triangle", "green-triangle", "blue-triangle",
                          "red-square", "green-square", "blue-square",
                          "red-circle", "green-circle", "blue-circle"];

    var minCeiled = Math.ceil(0);
    var maxFloored = Math.floor(9);
    var idx = Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
    className += " " + coloredshape[idx];
  }
  
  return (
    <div className={className}>
      <div>
        {/* {currentState.fade && <div className="fadestate active"></div>} */}
        {/* <h1 className="heading">Vote for this</h1> */}
        <h2>{currentBallot.description}</h2>
        {/* <p>{currentBallot.id}</p> */}
        {/* currentBallot.id == 1018 && <div><h2>We would really appreciate it if you could spend a few minutes to fill out this survey: </h2> <a className="survey-link button is-green" href="https://umdsurvey.umd.edu/jfe/form/SV_8GQnJ4s6Z4CPE8K">Survey Link (External)</a></div> */}
        {/* <h3>Prompts are:</h3> */}
        <ul className="no-indent">
          {currentBallot.prompts.map((p) => (
            <div className="panel">
              <li key={p.id}>
              {
                // only render the button if the ballot id is not in the list of already voted ids
                //!isVotedIdInStorage(currentBallot.id) && (
                // NOTE - WMK changed this to reverse fade test - prev was:
                <button onClick={() => DoVote(p)} className="button is-green" disabled={currentState.fade}>Vote</button>
                // <button onClick={() => DoVote(p)} className="button is-green" >Vote</button>
                // <Button onClick={() => DoVote(p)} as="a" variant="primary">
                // Vote
                // </Button>
                //)
              }
              <span> ({p.votes}) </span>
              <span> {p.name}</span>
              
              <div>&nbsp;</div>
            </li>
            
          </div>
          ))}
        </ul>
        {/*
        <span hidden={hideInput}>Your response: <input hidden={hideInput} id={userInputDataID} value={userInputData} 
                  onChange={(e) => {
                    const inputElement = e.target as HTMLInputElement;
                    console.log(inputElement.value);
                    setUserInputData(inputElement.value);
                  }}
                ></input>
        </span>
                */}
        </div>
      </div>
      );
    }
    
